// Moving the Boo app takes it from the Boo that holds it, so every step of
// the move names that Boo: the button, the confirm title and the confirm.
export function moveCopy({ label, holderName, place }: { label: string; holderName: string; place: string }) {
  return {
    button: `Move from ${holderName}`,
    title: `Disconnect ${holderName} from ${label}?`,
    description: `${holderName} stops answering in ${label} right away, and messages to Boo in ${place} reach this Boo instead.`,
    confirmLabel: `Disconnect ${holderName}`,
  };
}

